import { useAssetTrashContextMenu } from './TrashContextMenu/AssetTrashContextMenu';
import { useRecipeTrashContextMenu } from './TrashContextMenu/RecipeTrashContextMenu';
import { useMomentTrashContextMenu } from './TrashContextMenu/MomentTrashContextMenu';
import { useMemoryTrashContextMenu } from './TrashContextMenu/MemoryTrashContextMenu';
import { usePeopleTrashContextMenu } from './TrashContextMenu/PeopleTrashContextMenu';
import { useAssetFolderTrashContextMenu } from './TrashContextMenu/AssetFolderTrashContextMenu';
import { useRecipeFolderTrashContextMenu } from './TrashContextMenu/RecipeFolderTrashContextMenu';

export const useTrashContextMenu = () => {
  const assetTrash = useAssetTrashContextMenu();
  const recipeTrash = useRecipeTrashContextMenu();
  const momentTrash = useMomentTrashContextMenu();
  const memoryTrash = useMemoryTrashContextMenu();
  const peopleTrash = usePeopleTrashContextMenu();
  const assetFolderTrash = useAssetFolderTrashContextMenu();
  const recipeFolderTrash = useRecipeFolderTrashContextMenu();

  return {
    // Asset
    assetContextMenuItems: assetTrash.assetContextMenuItems,
    selectedAsset: assetTrash.selectedAsset,
    setSelectedAsset: assetTrash.setSelectedAsset,
    isDeleteAssetConfirm: assetTrash.isDeleteAssetConfirm,
    setIsDeleteAssetConfirm: assetTrash.setIsDeleteAssetConfirm,
    restoreAssetId: assetTrash.restoreAssetId,
    setRestoreAssetId: assetTrash.setRestoreAssetId,
    isAssetRestoreConfirm: assetTrash.isAssetRestoreConfirm,
    setIsAssetRestoreConfirm: assetTrash.setIsAssetRestoreConfirm,

    // Recipe
    recipeContextMenuItems: recipeTrash.recipeContextMenuItems,
    selectedRecipe: recipeTrash.selectedRecipe,
    setSelectedRecipe: recipeTrash.setSelectedRecipe,
    isRecipeDeleteConfirm: recipeTrash.isRecipeDeleteConfirm,
    setIsRecipeDeleteConfirm: recipeTrash.setIsRecipeDeleteConfirm,
    restoreRecipeId: recipeTrash.restoreRecipeId,
    setRestoreRecipeId: recipeTrash.setRestoreRecipeId,
    isRecipeRestoreConfirm: recipeTrash.isRecipeRestoreConfirm,
    setIsRecipeRestoreConfirm: recipeTrash.setIsRecipeRestoreConfirm,

    // Moment
    momentContextMenuItems: momentTrash.momentContextMenuItems,
    selectedMoment: momentTrash.selectedMoment,
    setSelectedMoment: momentTrash.setSelectedMoment,
    isMomentDeleteConfirm: momentTrash.isMomentDeleteConfirm,
    setIsMomentDeleteConfirm: momentTrash.setIsMomentDeleteConfirm,
    restoreMomentId: momentTrash.restoreMomentId,
    setRestoreMomentId: momentTrash.setRestoreMomentId,
    isMomentRestoreConfirm: momentTrash.isMomentRestoreConfirm,
    setIsMomentRestoreConfirm: momentTrash.setIsMomentRestoreConfirm,

    // Memory
    memoryContextMenuItems: memoryTrash.memoryContextMenuItems,
    selectedMemory: memoryTrash.selectedMemory,
    setSelectedMemory: memoryTrash.setSelectedMemory,
    isMemoryDeleteConfirm: memoryTrash.isMemoryDeleteConfirm,
    setIsMemoryDeleteConfirm: memoryTrash.setIsMemoryDeleteConfirm,
    restoreMemoryId: memoryTrash.restoreMemoryId,
    setRestoreMemoryId: memoryTrash.setRestoreMemoryId,
    isMemoryRestoreConfirm: memoryTrash.isMemoryRestoreConfirm,
    setIsMemoryRestoreConfirm: memoryTrash.setIsMemoryRestoreConfirm,

    // People
    peopleContextMenuItems: peopleTrash.peopleContextMenuItems,
    selectedPerson: peopleTrash.selectedPerson,
    setSelectedPerson: peopleTrash.setSelectedPerson,
    isPeopleDeleteConfirm: peopleTrash.isPeopleDeleteConfirm,
    setIsPeopleDeleteConfirm: peopleTrash.setIsPeopleDeleteConfirm,
    restorePersonId: peopleTrash.restorePersonId,
    setRestorePersonId: peopleTrash.setRestorePersonId,
    isPersonRestoreConfirm: peopleTrash.isPersonRestoreConfirm,
    setIsPersonRestoreConfirm: peopleTrash.setIsPersonRestoreConfirm,

    // Photo Folder
    photoFolderContextMenuItems: assetFolderTrash.photoFolderContextMenuItems,
    selectedPhotoFolder: assetFolderTrash.selectedPhotoFolder,
    setSelectedPhotoFolder: assetFolderTrash.setSelectedPhotoFolder,
    isDeletePhotoFolderConfirm: assetFolderTrash.isDeletePhotoFolderConfirm,
    setIsDeletePhotoFolderConfirm:
      assetFolderTrash.setIsDeletePhotoFolderConfirm,
    restorePhotoFolderId: assetFolderTrash.restorePhotoFolderId,
    setRestorePhotoFolderId: assetFolderTrash.setRestorePhotoFolderId,
    isPhotoFolderRestoreConfirm: assetFolderTrash.isPhotoFolderRestoreConfirm,
    setIsPhotoFolderRestoreConfirm:
      assetFolderTrash.setIsPhotoFolderRestoreConfirm,

    // Recipe Folder
    recipeFolderContextMenuItems:
      recipeFolderTrash.recipeFolderContextMenuItems,
    selectedRecipeFolder: recipeFolderTrash.selectedRecipeFolder,
    setSelectedRecipeFolder: recipeFolderTrash.setSelectedRecipeFolder,
    isDeleteRecipeFolderConfirm: recipeFolderTrash.isDeleteRecipeFolderConfirm,
    setIsDeleteRecipeFolderConfirm:
      recipeFolderTrash.setIsDeleteRecipeFolderConfirm,
    restoreRecipeFolderId: recipeFolderTrash.restoreRecipeFolderId,
    setRestoreRecipeFolderId: recipeFolderTrash.setRestoreRecipeFolderId,
    isRecipeFolderRestoreConfirm:
      recipeFolderTrash.isRecipeFolderRestoreConfirm,
    setIsRecipeFolderRestoreConfirm:
      recipeFolderTrash.setIsRecipeFolderRestoreConfirm
  };
};
